import { JsonSchema } from "store/json-schema";
import { num } from "./lang";

export type Diff = {
  blocks: { added: number, removed: number, changed: number },
  chains: { added: number, removed: number },
  text: string,
  sum: number
}

export const compareScheme = (schemeA: JsonSchema, schemeB: JsonSchema): Diff => {

  const blocks = { added: 0, removed: 0, changed: 0 }
  for (let [ blockId, block ] of Object.entries(schemeA.blocks)) {
    const blockB = schemeB.blocks[blockId]
    if (!schemeB.blocks[blockId]) {
      blocks.removed++
      continue
    }
    if (block.type !== blockB.type || !arrayEq(block.emitters, blockB.emitters) || !objectEq(block.data, blockB.data)) {
      blocks.changed ++
    }
  }
  for (let [ blockId ] of Object.entries(schemeB.blocks)) {
    if (!schemeA.blocks[blockId]) {
      blocks.added++
    }
  }

  const chains = { added: 0, removed: 0 }
  for (let { from, to } of schemeA.chains) {
    if (!schemeB.chains.find(ch => arrayEq(ch.from, from) && ch.to === to)) {
      chains.removed++
    }
  }
  for (let { from, to } of schemeB.chains) {
    if (!schemeA.chains.find(ch => arrayEq(ch.from, from) && ch.to === to)) {
      chains.added++
    }
  }
  const sum = blocks.added+blocks.changed+blocks.removed+chains.added+chains.removed

  const texts: string[] = []
  if (blocks.added || chains.added) {
    texts.push("Добавится " + gen(blocks.added, chains.added))
  }
  if (blocks.removed || chains.removed) {
    texts.push("Удалится " + gen(blocks.removed, chains.removed))
  }
  if (blocks.changed && texts.length < 2) {
    texts.push("Изменится " + gen(blocks.changed, 0))
  }
  const text = texts.join(". ")

  // if (blocks.changed) {
  //   text += "Изменится "+num(blocks.changed, "блок", "блока", "блоков")
  // } else if (blocks.added) {
  //   text += "Добавится "+num(blocks.added, "блок", "блока", "блоков")
  // } else if (blocks.removed) {
  //   text += "Удалится "+num(blocks.removed, "блок", "блока", "блоков")
  // }
  // if (chains.added) {
  //   text += (text === ""? "": ". ") + "Добавится "+num(chains.added, "связь", "связь", "связь")
  // } else if (chains.removed) {
  //   text += (text === ""? "": ". ") + "Удалится "+num(chains.removed, "связь", "связь", "связь")
  // }

  return { blocks, chains, sum, text }
}

const gen = (blocks: number, chains: number) => {
  const arr = [ blocks? num(blocks, "блок", "блока", "блоков"): "", chains? num(chains, "связь", "связь", "связь"): "" ]
    
  return arr.filter(i => !!i).join(" и ")
}

export const arrayEq = (a: (string | number)[], b: (string | number)[]) => {
  if (a.length !== b.length) return false
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false
  }
  return true
}

export const objectEq = (a: any, b: any) => {
  if (!arrayEq(Object.keys(a), Object.keys(b))) return false
  
  for (let key in a) {
    if (a[key] !== b[key]) {
      return false
    }
  }
  return true
}